<template>
  <el-dialog
      title="批量设置数据标签"
      top="10px"
      :fullscreen="true"
      :visible.sync="visible"
  >
    <div style="font-size: x-large; margin: 20px">
      <el-row :gutter="24">
        <el-col :span="6">总题数：{{questionCount}}</el-col>
        <el-col :span="6">已设置题数：{{questionSettledDataLabelCount}}</el-col>
        <el-col :span="6">已设置数据标签数：{{optionSettledDataLabelCount}}</el-col>
      </el-row>
    </div>
    <template v-for="question,index in dialogQuestions">
      <template v-if="isDataLabelOnQuestion(question.type)">
        <el-row :gutter="24">
          <el-col :span="16"><div class="grid-content bg-purple">Q{{index+1}} {{types[question.type]}} {{question.title}}</div></el-col>
          <el-col :span="8"><div class="grid-content">
            <el-input v-model="question.dataLabel" placeholder="最多不超过50个字符" size="small" maxlength="50"></el-input>
          </div></el-col>
        </el-row>
      </template>
      <template v-if="isDataLabelOnOption(question.type)">
        <el-row :gutter="24">
          <el-col :span="24"><div class="grid-content bg-purple">Q{{index+1}} {{types[question.type]}} {{question.title}}</div></el-col>
        </el-row>
        <el-row :gutter="24" v-for="option,index2 in question.options" v-bind:key="index + '_' + index2">
          <el-col :span="15" :offset="1"><div class="grid-content bg-purple">OPT{{index2+1}} {{option.title}}</div></el-col>
          <el-col :span="8"><div class="grid-content"><el-input v-model="option.dataLabel" placeholder="最多不超过50个字符" size="small" maxlength="50"></el-input></div></el-col>
        </el-row>
      </template>
    </template>

    <span slot="footer" class="dialog-footer">
    <el-button @click="close">取 消</el-button>
    <el-button type="primary" @click="confirm">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      callback: function () {},
      dialogQuestions: [],
    }
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      types: state => state.types,
    }),
    questionCount: function () {
      return this.dialogQuestions.length
    },
    questionSettledDataLabelCount: function () {
      return this.dialogQuestions.reduce((total, question) => {
        if (this.isDataLabelOnQuestion(question.type) && question.dataLabel.length) {
          return ++total
        }

        if (this.isDataLabelOnOption(question.type)) {
          for (let i in question.options) {
            if (question.options.hasOwnProperty(i) && question.options[i].dataLabel.length) {
              return ++total
            }
          }
        }

        return total
      }, 0)
    },
    optionSettledDataLabelCount: function () {
      return this.dialogQuestions.reduce((total, question) => {
        if (this.isDataLabelOnQuestion(question.type) && question.dataLabel.length) {
          return ++total
        }

        if (this.isDataLabelOnOption(question.type)) {
          let inc = 0
          for (let i in question.options) {
            if (question.options.hasOwnProperty(i) && question.options[i].dataLabel.length) {
              inc++
            }
          }

          return total + inc
        }

        return total
      }, 0)
    }
  },
  methods: {
    open (questions, callback) {
      this.visible = true
      this.dialogQuestions = filter.copyJson(questions)
      this.callback = callback
    },
    close () {
      this.visible = false
    },
    confirm () {
      this.visible = false
      this.callback(this.dialogQuestions)
    },
    isDataLabelOnQuestion (type) {
      return ['info', 'text', 'select'].includes(type)
    },
    isDataLabelOnOption (type) {
      return ['multitext', 'multiselect', 'imageMultiselect'].includes(type)
    }
  }
}
</script>

<style lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
   margin-bottom: 0;
 }
  &>.el-col>.grid-content {
    padding-left: 10px;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple {
  background: #e5e9f2;
  line-height: 36px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateDataLabels.vue